<div
  class="profile-select"
  (click)="openProfileSelectorModal()"
  [ngStyle]="{ width: width + 'px' }"
>
  <span *ngIf="!selectedProfile">...</span>
  <span *ngIf="selectedProfile">{{ selectedProfile.code }}</span>
</div>
